const errorReload = (error: string, retries = 1) => {
  console.error(error);

  const errRetries: string | null = sessionStorage.getItem("errRetries");
  if (typeof errRetries === "string") {
    if (parseInt(errRetries, 10) >= retries) {
      // we give up, the error persists
      return;
    }

    sessionStorage.setItem("errRetries", String(parseInt(errRetries, 10) + 1));
  } else {
    sessionStorage.setItem("errRetries", "1");
  }

  // refresh the page
  window.location.reload();
};

window.addEventListener("vite:preloadError", (_event) => {
  // retry 3 times to load the correct chunk on error,
  errorReload("Error during page load", 3);
});
